import styled from "styled-components";
import { AllieAccordion } from "../../../components/Accordion/Accordion";

interface StyledItemDesktopBodyProps {
  isTablet?: boolean;
  isDraft?: boolean;
}

export const StyledItemDesktopBody = styled.div<StyledItemDesktopBodyProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 50px;
  ${(props: StyledItemDesktopBodyProps) => props.isDraft ? 'padding-left: 20px;' : ''}
`;

export const StyledAccordion = styled(AllieAccordion)`
  ion-item::part(native) {
    background-color: transparent;
    padding-right: 0;
  }
  div[slot='content'] {
    overflow-wrap: anywhere;
  }
  ion-icon {
    width: 20px;
  }
`;
